function getSteps(group, exclude_individual = false)
{
    const steps = []

    if (group.cost_evaluation_comparative && group.cost_evaluation_comparative.reference)
    {
        steps.push({
            id : "reference",
            title : "Сравнительный подход",
            subtitle : "Метод типового (эталонного) объекта недвижимости",
            children : 
            [
                {
                    id : "reference_step1",
                    title : "Формирование типового (эталонного) объекта недвижимости",
                },
                {
                    id : "reference_step2",
                    title : "Определение кадастровой стоимости типового (эталонного) объекта недвижимости",
                    not_visible_children : true,
                    children :
                    [
                        {
                            id : "reference_step2_1",
                            title : "Метод сравнения продаж",
                        }
                    ]
                },
                {
                    id : "reference_step3",
                    title : "Корректировка стоимости типового (эталонного) объекта недвижимости",
                },
                {
                    id : "reference_step4",
                    title : "Расчет кадастровой стоимости",
                }
            ]
        })
    }

    if (group.cost_evaluation_comparative && group.cost_evaluation_comparative.approach == 'Сравнительный')
    {
        if (!group.cost_evaluation_comparative.modeling.fixed && !group.not_editable)
        {
            steps.push(
                {
                    id : "comparative",
                    title : "Сравнительный подход",
                    subtitle : "Метод статистического (регрессионного) моделирования",
                    children : 
                    [
                        {
                            id : "comparative_step1",
                            title : "Объекты-аналоги для построения статистической модели",
                        },
                        {
                            id : "comparative_step2",
                            title : "Статистический анализ",
                        },
                        {
                            id : "comparative_step3",
                            title : "Анализ статистической модели",
                            not_selectable : true,
                            not_visible : Object.keys(group.cost_evaluation_comparative.modeling.printable_formula_html).length == 0,
                            children :
                            [
                                {
                                    id : "comparative_step3_add",
                                    title : "Линейная",
                                    key : "add",
                                },
                                {
                                    id : "comparative_step3_mult",
                                    title : "Мультипликативная степенная",
                                    key : "mult",
                                },
                                {
                                    id : "comparative_step3_exp",
                                    title : "Экспоненциальная",
                                    key : "exp",
                                },
                            ].reduce(
                                (arr, model) => {
                                    if (group.cost_evaluation_comparative.modeling.printable_formula_html[model.key] != null)
                                    {
                                        arr.push(
                                            group.cost_evaluation_comparative.modeling.type == model.title
                                            ? { ...model, text_style : 'text-decoration: underline;'}
                                            : model
                                        )
                                    }
                                    return arr
                                }
                            , [])
                        },
                        {
                            id : "comparative_step4",
                            title : "Корректировки",
                        },
                        {
                            id : "comparative_step5",
                            title : "Расчет кадастровой стоимости",
                        },
                    ]
                }
            )
        }
        else
        {
            steps.push(
                {
                    id : "comparative",
                    title : "Сравнительный подход",
                    subtitle : "Метод статистического (регрессионного) моделирования",
                    children : 
                    [
                        {
                            id : "comparative_step2",
                            title : "Модель оценки",
                        },
                        {
                            id : "comparative_step4",
                            title : "Корректировки",
                        },
                        {
                            id : "comparative_step5",
                            title : "Расчет кадастровой стоимости",
                        },
                    ]
                }
            )
        }
    }
    
    if (group.cost_evaluation_expensive && group.cost_evaluation_expensive.approach == 'Затратный')
    {
        var data = group.cost_evaluation_expensive.comparative_element
        steps.push(
            {
                id : "expensive",
                title : "Затратный подход",
                subtitle : "Метод сравнительной единицы",
                children : 
                [
                    {
                        id : "expensive_step1",
                        title : "Подготовка объектов оценки",
                        is_ready : data.preparations.volume == data.total_objects
                            && data.preparations.floors_above_ground == data.total_objects
                            && data.preparations.floors_under_ground == data.total_objects
                            && data.preparations.cs == data.total_objects
                            && data.preparations.capital_group == data.total_objects
                            && data.preparations.seismicity == data.total_objects,
                        tooltip_value : `<strong>Строительный объем</strong> = Площадь *<br>
                            (Высота этажа * Количество надземных этажей для расчета<br>
                            + Толщина перекрытия * (Количество надземных этажей для расчета + Количество подземных этажей для расчета)<br>
                            + Высота этажа подвала * Количество подземных этажей для расчета)<br>
                            / (Количество надземных этажей для расчета + Количество подземных этажей для расчета) * 1<br>
                            / Коэффициент толщины стен`
                    },
                    {
                        id : "expensive_step2",
                        title : "Подбор объектов-аналогов",
                        is_ready : data.not_found_count == 0,
                    },
                    {
                        id : "expensive_step3",
                        title : "Настройка параметров расчета",
                        not_selectable : true,
                        children :
                        [
                            {
                                id : "expensive_step3_1",
                                title : "Расчет прибыли предпринимателя",
                            },
                            {
                                id : "expensive_step3_2",
                                title : "Расчет совокупного износа",
                                is_ready : !!(data.wear.custom.value && data.wear.custom.source),
                            },
                        ],
                    },
                    {
                        id : "expensive_step4",
                        title : "Расчет кадастровой стоимости",
                    },
                ]
            }
        )
    }

    if (group.cost_evaluation_profitable)
    {
        if (!group.not_editable)
        {
            steps.push(
                {
                    id : "profitable",
                    title : "Доходный подход",
                    subtitle : "Метод прямой капитализации",
                    children : 
                    [
                        {
                            id : "profitable_step1",
                            title : "Чистый операционный доход",
                            not_visible_children : true,
                            children :
                            [
                                {
                                    id : "profitable_step1_1",
                                    title : "Действительный валовой доход",
                                    not_visible_children : true,
                                    children :
                                    [
                                        {
                                            id : "profitable_step1_1_1",
                                            title : "Потенциальный валовой доход",
                                            not_visible_children : true,
                                            children :
                                            [
                                                {
                                                    id : "profitable_step1_1_1_1",
                                                    title : "Настройка расчета",
                                                },
                                                {
                                                    id : "profitable_step1_1_1_2",
                                                    title : "Подбор объектов-аналогов",
                                                    not_visible : true,
                                                },
                                                {
                                                    id : "profitable_step1_1_1_3",
                                                    title : "Учет фактора сезонности",
                                                    not_visible : true,
                                                }
                                            ]
                                        },
                                        {
                                            id : "profitable_step1_1_2",
                                            title : "Потери от недозагрузки",
                                        },
                                        {
                                            id : "profitable_step1_1_3",
                                            title : "Потери при сборе арендной платы",
                                        }
                                    ]
                                },
                                {
                                    id : "profitable_step1_2",
                                    title : "Операционные расходы",
                                }
                            ]
                        },
                        {
                            id : "profitable_step2",
                            title : "Ставка капитализации",
                            not_visible_children : true,
                            children :
                            [
                                {
                                    id : "profitable_step2_1",
                                    title : "Чистый операционный доход объектов-аналогов",
                                },
                                {
                                    id : "profitable_step2_2",
                                    title : "Подбор объектов-аналогов",
                                },
                            ],
                        },
                        {
                            id : "profitable_step3",
                            title : "Наиболее вероятная доля стоимости объекта оценки в стоимости единого объекта недвижимости",
                        },
                        {
                            id : "profitable_step4",
                            title : "Расчет кадастровой стоимости",
                        },
                    ]
                }
            )
        }
        else
        {
            steps.push(
                {
                    id : "profitable",
                    title : "Доходный подход",
                    subtitle : "Метод прямой капитализации",
                    children : 
                    [
                        {
                            id : "profitable_step1",
                            title : "Чистый операционный доход",
                            not_visible_children : true,
                            children :
                            [
                                {
                                    id : "profitable_step1_1",
                                    title : "Действительный валовой доход",
                                    not_visible_children : true,
                                    children :
                                    [
                                        {
                                            id : "profitable_step1_1_1",
                                            title : "Потенциальный валовой доход",
                                        },
                                        {
                                            id : "profitable_step1_1_2",
                                            title : "Потери от недозагрузки",
                                        },
                                        {
                                            id : "profitable_step1_1_3",
                                            title : "Потери при сборе арендной платы",
                                        }
                                    ]
                                },
                                {
                                    id : "profitable_step1_2",
                                    title : "Операционные расходы",
                                }
                            ]
                        },
                        {
                            id : "profitable_step2",
                            title : "Ставка капитализации",
                        },
                        {
                            id : "profitable_step3",
                            title : "Наиболее вероятная доля стоимости объекта оценки в стоимости единого объекта недвижимости",
                        },
                        {
                            id : "profitable_step4",
                            title : "Расчет кадастровой стоимости",
                        },
                    ]
                }
            )
        }
    }

    if((!(group.cost_evaluation_comparative || group.cost_evaluation_expensive || group.cost_evaluation_profitable) || (group.cost_evaluation_individual && group.cost_evaluation_individual.individual)) && !exclude_individual)
    {
        steps.push(
            {
                id : "individual",
                title : "Индивидуальный расчет",
            },
			{
				id : "individual_results",
				title : "Расчет кадастровой стоимости",
			},
        )
    }

    if (group.cost_evaluation_comparative && group.cost_evaluation_comparative.modeling && !group.cost_evaluation_comparative.modeling.fixed
        || group.cost_evaluation_expensive || group.cost_evaluation_profitable)
    {
        steps.push(
            {
                id : "results",
                title : "Согласование результатов определения кадастровой стоимости",
            }
        )
    }

    return steps
}

export default
{
    getSteps
}
